module.exports = __webpack_public_path__ + "static/hg-c035122acea8b91af593667098f75628.jpg";